'use client'

import { useAnalytics } from '@/hooks/useAnalytics'

type ExternalLinkType =
  | 'website'
  | 'github'
  | 'appstore'
  | 'demo'
  | 'changelog'
  | 'other'

/**
 * Centralizes the `external_link_click` analytics event so the event name and
 * payload shape can't drift across call sites (ProjectCard, project detail,
 * craft tiles, currently-reading, …). Returns a stable tracker.
 */
export function useExternalLinkTracking() {
  const { track } = useAnalytics()

  return (
    destination: string,
    context: string,
    type: ExternalLinkType = 'website',
  ) => track('external_link_click', { destination, context, type })
}
